




















































































































import { Component } from 'vue-property-decorator';
import { SwTable } from '@libs-uuif/shared/sw-table';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { TableColumnConfig, SortedColumnInfo, ColumnSortRequestData, ColumnsAdjustRequestData } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { SwTitlePane } from '@sonicwall/unified-ui-framework/src/shared/sw-title-pane';
import { SwTextarea } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { MswAppTitle } from '@/shared/msw-app-title';
import Vue from 'vue';
const cssPrefix = 'msw-myflexspend';
@Component({
  components: {
    SwTable,
    SwTitlePane,
    SwTextarea,
    SwButton,
    MswAppTitle,
  },
  directives: {},
})
export default class MswMyFlexspend extends SwExtendedVue {
  cssPrefix = cssPrefix;
  availableCredits = '';
  allocatedCredits = '';
  tableData = [];
  activationCodes = '';
  isLoadingTableData: boolean = false;
  sortedColumns: SortedColumnInfo[] = [];
  tableConfigArr(): TableColumnConfig[] {
    return [
      {
        key: 'registereddate',
        dataKey: 'dtregistereddate',
        title: this.$t('flexspend.regDate')
        .toString(),
        sorter: true,
        width: 140,
      },
      {
        key: 'name',
        dataKey: 'name',
        title: this.$t('common.description')
        .toString(),
        sorter: true,
        width: 320,
      },
      {
        key: 'ssipn',
        dataKey: 'ssipn',
        title: this.$t('flexspend.ssipn')
        .toString(),
        sorter: true,
        width: 125,
      },
      {
        key: 'dispLicense',
        dataKey: 'dispLicense',
        title: this.$t('flexspend.actCode')
        .toString(),
        sorter: true,
        width: 285,
      },
      {
        key: 'amount',
        dataKey: 'amount',
        title: this.$t('flexspend.crdts')
        .toString(),
        sorter: true,
        width: 100,
      },
      {
        key: 'createdby',
        dataKey: 'createdby',
        title: this.$t('flexspend.regBy')
        .toString(),
        sorter: true,
      },
    ];
  }
  flexspendTableConfig: TableColumnConfig[] = this.tableConfigArr();

  onRequestSorting(data: ColumnSortRequestData) {
    data.cancel = false;
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.ascending === undefined) {
        this.sortedColumns[index].ascending = !this.sortedColumns[index].ascending;
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }

  onRequestColumnAdjust(data: ColumnsAdjustRequestData) {
    this.flexspendTableConfig.forEach((col) => {
      const adjustInfo = data[col.key];
      if (!adjustInfo) {
        return;
      }
      Vue.set(col, 'width', adjustInfo);
    });
  }

  mounted() {
    this.getDetails();
  }

  getDetails() {
    this.isLoadingTableData  = true;
    this.$store.dispatch(
      'FlexspendStoreModule/getFlexspendDetails',
    )
    .then((resp) => {
      this.isLoadingTableData = false;
      if (resp.content) {
        this.availableCredits = resp.content.balance;
        this.allocatedCredits = resp.content.servicecost;
      }
      if (resp.content.fsSerialList) {
        this.tableData = resp.content.fsSerialList;
      }
    });
  }
}
